module.exports = __webpack_public_path__ + "img/night_Icon.aead25c8.png";